import { API } from "../common/Constants";

export const tokenId = localStorage.getItem('agentModuleToken');

export const reqHeaders = {
    Authorization: `Bearer ${tokenId}`
};

export const IMAGE_BASE_URL = 'https://api.ohhto.com/';
// export const IMAGE_BASE_URL = 'http://localhost:8000/v1/';
